'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { AuthApi } from '@/api';
import { DONATION_ROUTES, ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';
import { MarketButton } from './MarketButton';
import { MarketShareDrawer } from './MarketShareDrawer';
import { type ModalType, RandomTicketModal } from './RandomTicketModal';
interface RandomDrawClientProps {
  className?: string;
  children?: React.ReactNode;
  dimensions?: 'H56' | 'H48' | 'H40' | 'H32' | 'H26' | null | undefined;
}
interface ModalState {
  type: ModalType;
  point: number;
}
export const RandomDrawClient = t0 => {
  const $ = _c(28);
  const {
    className,
    children,
    dimensions
  } = t0;
  const {
    push
  } = useCustomRouter();
  const {
    toastError
  } = useToast();
  const [modalState, setModalState] = useState(null);
  const [isShareDrawerOpen, setIsShareDrawerOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = result => setModalState(result);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== toastError) {
    t2 = {
      mutationFn: _temp,
      onSuccess: t1,
      onError: error => toastError({
        error
      })
    };
    $[1] = toastError;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    mutate,
    isPending
  } = useMutation(t2);
  let t3;
  if ($[3] !== mutate || $[4] !== push) {
    t3 = () => {
      const {
        isLogin
      } = useAuthStore.getState();
      if (!isLogin) {
        push(ROUTES.LOGIN.withSearchParams({
          searchParams: {
            redirect: location.href
          }
        }));
        return;
      }
      mutate();
    };
    $[3] = mutate;
    $[4] = push;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleClick = t3;
  let t4;
  if ($[6] !== modalState || $[7] !== push) {
    t4 = () => {
      if (!modalState) {
        return;
      }
      setModalState(null);
      bb48: switch (modalState.type) {
        case "win":
          {
            push(ROUTES.POINT_MARKET.pathname);
            break bb48;
          }
        case "not-eligible":
          {
            push(`${DONATION_ROUTES.HOME.pathname}?utm_source=wello&utm_medium=max_event&utm_campaign=buttn_donation&utm_content=donation_251203`);
            break bb48;
          }
        case "already-participated":
          {
            setIsShareDrawerOpen(true);
          }
      }
    };
    $[6] = modalState;
    $[7] = push;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handlePrimaryClick = t4;
  let t5;
  if ($[9] !== children || $[10] !== className || $[11] !== dimensions || $[12] !== handleClick || $[13] !== isPending) {
    t5 = <MarketButton dimensions={dimensions} className={className} onClick={handleClick} disabled={isPending}>{children}</MarketButton>;
    $[9] = children;
    $[10] = className;
    $[11] = dimensions;
    $[12] = handleClick;
    $[13] = isPending;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = modalState !== null;
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setModalState(null);
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = modalState?.type ?? "win";
  const t9 = modalState?.point ?? 0;
  let t10;
  if ($[16] !== handlePrimaryClick || $[17] !== t6 || $[18] !== t8 || $[19] !== t9) {
    t10 = <RandomTicketModal isOpen={t6} onClose={t7} type={t8} point={t9} onPrimaryClick={handlePrimaryClick} />;
    $[16] = handlePrimaryClick;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setIsShareDrawerOpen(false);
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== isShareDrawerOpen) {
    t12 = <MarketShareDrawer opened={isShareDrawerOpen} onClose={t11} />;
    $[22] = isShareDrawerOpen;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t12 || $[26] !== t5) {
    t13 = <>{t5}{t10}{t12}</>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t5;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
async function _temp() {
  const {
    data
  } = await AuthApi["get:/wello/v2/auth/home/event/december/random-ticket-count"]();
  const context = data?.context;
  if (!context) {
    throw new Error("context is empty");
  }
  const {
    randomTicketId: random_ticket_id,
    event2AvailYN: event2_avail_yn
  } = context;
  if (random_ticket_id === null) {
    return {
      type: (event2_avail_yn ? "not-eligible" : "already-participated") as ModalType,
      point: 0
    };
  }
  const {
    data: openData
  } = await AuthApi["put:/wello/v2/auth/home/event/december/random-ticket/{randomTicketId}"]({
    path: {
      randomTicketId: random_ticket_id
    }
  });
  const pointContext = openData?.context;
  if (!pointContext?.resultYN) {
    throw new Error(pointContext?.message || "\uC6F0\uD3EC\uC778\uD2B8 \uC9C0\uAE09\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
  }
  return {
    type: "win" as ModalType,
    point: pointContext.addPoints
  };
}